import type { PostAuthGetSessionResponse } from '@repo/api-portal-sdk/gen'

export function normalizePortalSession(data: PostAuthGetSessionResponse) {
	if (data.sessionType === 'mfa_pending') {
		if (!data.mfa) {
			throw new Error('Pending MFA session payload is incomplete')
		}
		return {
			sessionType: 'mfa_pending' as const,
			mfa: data.mfa
		}
	}

	if (data.sessionType !== 'authenticated') {
		return { sessionType: 'anonymous' as const }
	}

	if (!(data.csrfToken && data.session && data.user)) {
		throw new Error('Authenticated session payload is incomplete')
	}

	return {
		sessionType: 'authenticated' as const,
		csrfToken: data.csrfToken,
		session: data.session,
		user: data.user
	}
}

export function isPortalSessionAuthorized(
	session: ReturnType<typeof normalizePortalSession>
) {
	return session.sessionType === 'authenticated' && !session.user.isAnonymous
}
